// Downscale an image data URL to a JPEG no larger than maxSize px on its long
// edge. Phone photos are several MB; the hosted database can't hold those.
export function resizeImage(dataUrl, maxSize = 1024, quality = 0.7) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/jpeg', quality));
    };
    img.onerror = () => reject(new Error('Unable to read image'));
    img.src = dataUrl;
  });
}
